export default "__VITE_ASSET__CEa_zMcH__"